import { Route, Routes } from "react-router-dom";
import { TaxClosing } from "./index";
import { DataVisualizationPage } from "./dashboard";

export default function TaxClosingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<TaxClosing />} />
      <Route path="/:jobId" element={<DataVisualizationPage />} />
    </Routes>
  );
}
